import React from 'react';
import { Link } from 'react-router-dom';
import { FoxLogo } from './FoxLogo';
import { Twitter, Facebook, Instagram, Github } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-950 pt-20 pb-10 border-t border-slate-800" data-id="element-1680">
      <div className="container mx-auto px-4 md:px-6" data-id="element-1681">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 mb-16" data-id="element-1682">
          <div className="lg:col-span-2" data-id="element-1683">
            <div className="flex items-center gap-2 mb-6" data-id="element-1684">
              <FoxLogo className="w-8 h-8" data-id="element-1685" />
              <span className="font-heading font-bold text-xl text-white tracking-tight" data-id="element-1686">
                Fox Line <span className="text-fox-500" data-id="element-1687">Hosting</span>
              </span>
            </div>
            <p className="text-slate-400 mb-6 max-w-sm" data-id="element-1688">
              Premium web hosting services designed for speed, security, and
              reliability. Join the fox pack today.
            </p>
            <div className="flex gap-4" data-id="element-1689">
              {[Twitter, Facebook, Instagram, Github].map((Icon, i) => <a key={i} href="#" className="w-10 h-10 rounded-full bg-slate-900 border border-slate-800 flex items-center justify-center text-slate-400 hover:text-fox-400 hover:border-fox-500/50 transition-colors" data-id="element-1690">
                  <Icon size={18} data-id="element-1691" />
                </a>)}
            </div>
          </div>

          <div data-id="element-1692">
            <h4 className="text-white font-bold mb-6 font-heading" data-id="element-1693">Services</h4>
            <ul className="space-y-3" data-id="element-1694">
              {['Web Hosting', 'VPS Hosting', 'Dedicated Servers', 'Domain Names', 'SSL Certificates'].map(item => <li key={item} data-id="element-1695">
                  <a href="#" className="text-slate-400 hover:text-fox-400 transition-colors text-sm" data-id="element-1696">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>

          <div data-id="element-1697">
            <h4 className="text-white font-bold mb-6 font-heading" data-id="element-1698">Company</h4>
            <ul className="space-y-3" data-id="element-1699">
              {['About Us', 'Contact', 'Careers', 'Blog', 'Affiliates'].map(item => <li key={item} data-id="element-1700">
                    <a href="#" className="text-slate-400 hover:text-fox-400 transition-colors text-sm" data-id="element-1701">
                      {item}
                    </a>
                  </li>)}
            </ul>
          </div>

          <div data-id="element-1702">
            <h4 className="text-white font-bold mb-6 font-heading" data-id="element-1703">Legal</h4>
            <ul className="space-y-3" data-id="element-1704">
              {['Terms of Service', 'Privacy Policy', 'Cookie Policy', 'Acceptable Use', 'SLA'].map(item => <li key={item} data-id="element-1705">
                  <a href="#" className="text-slate-400 hover:text-fox-400 transition-colors text-sm" data-id="element-1706">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-1707">
          <p className="text-slate-500 text-sm" data-id="element-1708">
            © {new Date().getFullYear()} Fox Line Hosting. All rights reserved.
          </p>
          <div className="flex items-center gap-4" data-id="element-1709">
            <div className="flex items-center gap-2 text-slate-500 text-sm" data-id="element-1710">
              <span data-id="element-1711">Made with</span>
              <span className="text-fox-500" data-id="element-1712">♥</span>
              <span data-id="element-1713">for the web</span>
            </div>
            <Link to="/backend" className="text-slate-700 hover:text-slate-500 text-xs transition-colors" data-id="element-1714">
              Backend
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}